<div class="db-image-optimizer-success__wrap">
  <h1>Your images were successfully optimized</h1>
  <div class="db-image-optimizer-success__metrics-wrap">
    <div class="db-image-optimizer-success__metrics">
      <div class="db-image-optimizer-success__checkmark">
        <div>
          <i class="db-icon db-icon-ds-checkmark"></i>
        </div>
      </div>
      <p class="metric-name">Optimized images</p>
      <p class="metric-value">{{report?.imagesCount}}</p>
    </div>
    <div class="db-image-optimizer-success__metrics">
      <div class="db-image-optimizer-success__checkmark">
        <div>
          <i class="db-icon db-icon-ds-checkmark"></i>
        </div>
      </div>
      <p class="metric-name">Reduced size</p>
      <p *ngIf="!!report?.imagesSize" class="metric-value" [innerHTML]="report?.imagesSize | size: {unit: 'B'}"></p>
    </div>
  </div>

  <div class="db-image-optimizer-success__score-wrap">
    <h4>But your website is not optimized yet, current score:</h4>
    <div>
      <div class="db-image-optimizer-success__score-block">
        <ds-score [score]="currentScore?.desktopScore" [withShadow]="false" size="m" [lineWidth]="2"></ds-score>
        <div>
          <p class="label">Desktop score</p>
          <p class="value">Load time: {{currentScore.desktopTTI}}</p>
        </div>
      </div>
      <div class="db-image-optimizer-success__score-block">
        <ds-score [score]="currentScore.mobileScore" [withShadow]="false" size="m" [lineWidth]="3"></ds-score>
        <div>
          <p class="label">Mobile score</p>
          <p class="value">Load time: {{currentScore.mobileTTI}}</p>
        </div>
      </div>
    </div>

  </div>

  <div class="db-image-optimizer-success__features-wrap">
    <h5>Activate 10Web Booster and automatically get:</h5>
    <ul class="db-image-optimizer-success__features">
      <li *ngFor="let feature of features"><i class="db-icon db-icon-ds-dot"></i>{{feature}}</li>
    </ul>
  </div>

  <div class="text-center">
    <button class="ds-btn-green ds-btn-xl rectangle" (click)="redirectToWp()">
      <span>Install & Activate</span>
    </button>
  </div>
</div>
<div class="db-image-optimizer-success__img-wrap"></div>
